export default __webpack_public_path__ + "static/media/Mobile.79383b5d.jpg";